/**
 * Web Style Import
 *
 */

import './style/dnb-stat.scss'
